/**************************************************************************************************************************************************
*   MODULE NAME     :  DateFormat
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  05-01-2021
*   DESCRIPTION     :  Common Component for Not Found Routes.
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import React from "react";
import { withRouter } from "react-router-dom";
import "./NotFound.css";

class NotFound extends React.Component {
  render() {
    return (
      <div className="notFoundWrap">
        <div className="innerContainer">
          <div className="unauthorized_Error">
            <h1>Page Not Found</h1>
            <p>
              The page you requested could not be found!
              <br />
              Please contact your Business Admin.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(NotFound);
